import { LOAD_MORE_ROW_COUNT } from '../../data-loading/TableLoadingConstants';
import { onLoadMoreRowsFailed, onLoadMoreRowsSucceeded } from '../onLoadMoreRowsCompleted';
import { appendItemWithSeekToConditionResponse } from 'owa-mail-list-response-processor';
import { getBaseFolderId } from 'owa-mail-list-store';
import { getMailboxInfoFromTableQuery } from 'owa-mail-mailboxinfo';
import { findItemWithSeekToCondition } from 'owa-mail-store/lib/services/findItemWithSeekToCondition';
import getMailItemSortByProperty from '../../../utils/tables/getMailItemSortByProperty';
/**
 * Load more items from the server
 * @param tableView to load
 */
export default function loadMoreItemsFromServer(tableView) {
    var lastItemIndex = tableView.rowKeys.length - 1;
    var mailTableQuery = tableView.tableQuery;
    // We always perform seek to condition request when we are loading more.
    // We use instancekey of the last item we have in the loaded rows in the table.
    // The seekToCondition ask server to get items from this instanceKey the response of which will also
    // include the last item who instanceKey we used.
    findItemWithSeekToCondition(getBaseFolderId(mailTableQuery), tableView.rowKeys[lastItemIndex], LOAD_MORE_ROW_COUNT, mailTableQuery.viewFilter, getMailItemSortByProperty(mailTableQuery), mailTableQuery.focusedViewFilter, mailTableQuery.requestShapeName, getMailboxInfoFromTableQuery(mailTableQuery).requestOptions, mailTableQuery.categoryName).then(function (responseMessage) {
        if (responseMessage.ResponseClass === 'Success') {
            onLoadMoreRowsSucceeded(tableView, responseMessage.RootFolder.Items, responseMessage.RootFolder.TotalItemsInView, appendItemWithSeekToConditionResponse);
        }
        else {
            onLoadMoreRowsFailed(tableView, responseMessage.ResponseCode);
        }
    }, function (error) {
        onLoadMoreRowsFailed(tableView);
    });
}
//# sourceMappingURL=loadMoreItemsFromServer.js.map